import { useCallback, useEffect, useRef, useState } from "react";
import { get, set, clear } from "idb-keyval";
import api from "./api";
import { useAuth } from "../context/AuthContext";

const mem = new Map();

export const clearDataCache = () => { mem.clear(); clear().catch(() => {}); };

// Affiche immédiatement la dernière liste connue (mémoire / IndexedDB) puis la rafraîchit en arrière-plan.
export function useCachedList(url) {
  const { user } = useAuth();
  const key = `${user?.user_id || "anon"}:${url}`;
  const [data, setData] = useState(() => mem.get(key) || []);
  const [loaded, setLoaded] = useState(mem.has(key));
  const fresh = useRef(false);

  const reload = useCallback(() => api.get(url).then((r) => {
    fresh.current = true;
    setData(r.data || []);
    setLoaded(true);
  }).catch(() => setLoaded(true)), [url]);

  useEffect(() => {
    if (!mem.has(key)) {
      get(key).then((v) => { if (v && !fresh.current) { setData(v); setLoaded(true); } }).catch(() => {});
    }
    reload();
  }, [key, reload]);

  useEffect(() => {
    if (!fresh.current) return;
    mem.set(key, data);
    set(key, data).catch(() => {});
  }, [key, data]);

  return [data, setData, loaded, reload];
}
